// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41817384","453":"233d5f25","622":"33f46b81","977":"4bd71355"}[chunkId] + ".chunk.js";
};